import React from 'react';
import { Box, BoxProps } from '@withjoy/joykit';

interface PhotoProps
  extends BoxProps,
    Readonly<{
      photoUrl: string;
      name: string;
    }> {}

export const Photo: React.FC<PhotoProps> = ({ photoUrl, name, children, ...boxProps }) => {
  return (
    <Box
      position="relative"
      width="100%"
      aspectRatio="16/9"
      overflow="hidden"
      backgroundColor="mono2"
      {...boxProps}
    >
      <Box
        as="img"
        src={photoUrl}
        alt={name}
        width="100%"
        height="100%"
        objectFit="cover"
        aria-hidden={true}
      />
      {children}
    </Box>
  );
};
